import React from 'react';
import PropTypes from 'prop-types';
import { FlatButton } from '@reservamos/elements';
import { trackEvent } from 'user-analytics';
import { YAPE_INFO_MODAL_OPENED } from 'constants/TrackEvents';

/**
 * YapeInfoButton component.
 * Renders a button to open the Yape information modal.
 * @param {Object} props - Component props
 * @param {Function} props.onClick - Function to call when button is clicked
 * @param {string} props.text - Button text content
 */
const YapeInfoButton = ({ onClick, text }) => {
  /**
   * Handles the click event for the Yape info button.
   */
  const handleClick = () => {
    trackEvent(YAPE_INFO_MODAL_OPENED, {
      'Modal Type': 'Yape OTP Instructions',
      'Source': 'Payment Form',
    });

    onClick();
  };

  return (
    <div className="flex justify-start mt-4">
      <FlatButton onClick={handleClick} variant="link" size="S" text={text} />
    </div>
  );
};

YapeInfoButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};

export default YapeInfoButton;
